import { create } from "zustand";
import { Discipline } from "@prisma-remote/client";
import { apiClient } from "src/services/apiClient";

interface DisciplineState {
  disciplines: Discipline[];
  fetchDisciplines: (organisationId?: string) => Promise<void>;
}

export const useDisciplineStore = create<DisciplineState>((set) => ({
  disciplines: [],
  fetchDisciplines: async (organisationId) => {
    const query = organisationId
      ? `?organisationId=${encodeURIComponent(organisationId)}`
      : "";
    try {
      const disciplines = await apiClient.get<Discipline[]>(
        `/disciplines${query}`,
        { requiresAuth: false },
      );
      set({ disciplines });
    } catch {
      set({ disciplines: [] });
    }
  },
}));
